<template>
    <div class="container">
        <b-modal
            :model-value="modCrearCentroCostos"
            :no-close-on-backdrop="true"
            hide-footer
            hide-header-close
            centered
            :title="labels.title"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog"
        >
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-3">
                    <div class="password-policy-title">
                        {{ labels.formInfoTitle }}
                    </div>
                    <div class="password-policy-item">
                        {{ labels.formInfoSubtitle }}
                    </div>
                </div>
                <b-col md="4" lg="12" class="p-0 mx-auto">
                    <b-form-group>
                        <label>{{ labels.codigo }}</label>
                        <b-form-input
                            v-model="form.codigo"
                            type="number"
                            class="reset-input"
                        ></b-form-input>
                        <label>{{ labels.descripcion }}</label>
                        <b-form-input
                            v-model="form.descripcion"
                            type="text"
                            class="reset-input"
                        ></b-form-input>
                        <label>{{ labels.centro_costo }}</label>
                        <b-form-input
                            v-model="form.centro_costo"
                            type="text"
                            class="reset-input"
                        ></b-form-input>
                    </b-form-group>
                    <div class="reset-dialog-actions d-flex justify-content-end mt-3 uniform-actions-wrap">
                        <b-button
                            class="mr-2 reset-btn-secondary"
                            @click="cierraModal()"
                        >
                            {{ labels.close }}
                        </b-button>
                        <b-button
                            class="reset-btn-primary"
                            @click="guardarCentroCostos()"
                        >
                            {{ labels.save }}
                        </b-button>
                    </div>
                </b-col>                
            </div>
        </b-modal>
    </div>
</template>

<script>
import CentroCostos from '../../../services/CentroCostos' 
export default {
    name : 'Crear',
    props:{
        modCrearCentroCostos: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form: {
                codigo: "",
                descripcion: "",
                centro_costo: ""
            }
        }
    },
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Crear centro de costo',
                    save : 'Guardar',
                    close : 'Cerrar',
                    codigo : 'Código',
                    descripcion : 'Descripción',
                    centro_costo : 'Centro de costo',
                    formInfoTitle: "Datos del centro de costo",
                    formInfoSubtitle: "Completa la información y guarda el nuevo centro de costo."
                }
            }else{
                return {
                    title : 'Create cost center',
                    save : 'Save',
                    close : 'Close',
                    codigo : 'Code',
                    descripcion : 'Description',
                    centro_costo : 'Cost center',
                    formInfoTitle: "Cost center data",
                    formInfoSubtitle: "Complete the information and save the new cost center."
                }
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false) 
        },
        guardarCentroCostos(){

            if (!this.form.codigo || !this.form.descripcion.trim() || !this.form.centro_costo.trim()) {
                this.$toast.error("Campo(s) pendiente(s) por diligenciar");
                return;
            }

            const info = {
                'codigo' : this.form.codigo, 
                'descripcion' : this.form.descripcion, 
                'centro_costo' : this.form.centro_costo, 
                'idUser' : this.$store.state.userId 
            }
            // console.log(info);

            CentroCostos.createCentroCostos(info) 
            .then((res) => { 
                if(res.status == 201){ 
                    this.$toast.success(res.data.message) 
                    this.$emit("creado");
                    this.cierraModal();
                }
            })
            .catch((err) => { 
                if(err.response.status == 409){ 
                    this.$toast.error(err.response.data.message) 
                }else{
                    this.$toast.error("Algo pasó, intentalo de nuevo") 
                }
            })            
        }
    },
}
</script>

<style>

</style>
